(function (angular, TeamAPI, TSUtils) {
    "use strict";

    /**
     * @namespace TeamScheduleService
     *
     * @param hUser
     * @param userPermissions
     * @param $stateParams
     * @param $state
     * @returns {TeamScheduleService}
     * @constructor
     */
    function TeamScheduleService(hUser, userPermissions, $stateParams, $state, userBrandsTreeService, $q) {
        var self = this;
        var emitter = JarEventEmitter.call(self);
        var getBrandsPromise = null;
        var _brands = [];
        var _activeBrand = {};
        var _activeBusinessBrand = {};
        var businessBrandsMap = {};
        var userBusinesses = [];
        var employeeBusinessSettings = {};
        var brandWithNoAccessMap = {};

        const BREAD_COUNTS_BRANDS = [
            6020249, 4460857, 5322452
        ];


        self.isBreadCountBrand = (brand) => {
            return (
                BREAD_COUNTS_BRANDS.includes(brand.id) ||
                BREAD_COUNTS_BRANDS.includes(brand.parent_id)
            );
        };

        var isServiceEnabled = function (service, brand) {
            brand = brand || _activeBrand;
            return brand && brand.hasOwnProperty('id')
                && (brand.services.indexOf(service) > -1);
        };

        self.checkIfBrandHasAnonymousUsers = function (brandId) {
            var defer = $q.defer();
            var payload = {brand_ids: [brandId]};
            TeamAPI.checkIfBrandsHasAnonymousUsers(brandId, payload)
                .then(function (brands) {
                    var hasAnonymousEmployees = brands && brands[0]['has_anonymous_employees'];
                    defer.resolve(hasAnonymousEmployees);
                }, function (error) {
                    console.error(error);
                    hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong!"));
                });
            return defer.promise;
        };

        var isRoleEnabled = function (role) {

            return _activeBrand && _activeBrand.hasOwnProperty('id')
                && (_activeBrand.roles.indexOf(role) > -1)
        };

        /**
         * @name TeamScheduleService#onBrandChanged
         *
         * @param handler
         */
        self.onBrandChanged = function (handler) {
            return self.on("brand-changed", handler);
        };

        self.onBrandUpdated = function (handler) {
            return self.on("brand-updated", handler);
        };

        self.onShiftsUpdated = function (handler) {
            return self.on("shifts-updated", handler);
        };

        self.onSchedulePublished = function (handler) {
            return self.on("schedule-published", handler);
        };

        self.onRatesUpdated = function (handler) {
            return self.on("rates-updated", handler);
        };

        self.onScheduleUpdated = function (handler) {
            return self.on("schedule-updated", handler);
        };

        self.triggerRatesUpdated = function () {
            emitter.trigger("rates-updated")
        };

        self.triggerShiftsUpdated = function (shift) {
            emitter.trigger("shifts-updated", shift)
        };

        self.triggerSchedulePublished = function () {
            emitter.trigger("schedule-published")
        };

        self.triggerScheduleUpdated = function () {
            emitter.trigger("schedule-updated")
        };

        self.isPaySheetAdmin = function () {
            return isRoleEnabled("PAY_SHEET_ADMIN");
        };

        self.isClockTimeAppEnabled = function () {
            return isServiceEnabled("HARRI_CLOCK");
        };

        self.isEmployeeBusinessHasCommsHubEnabled = function (BusinessId) {
            var defer = $q.defer();
            self.getEmployeeBusinesses().then(function (Businesses) {
                var isActiveEmployeeBusinessHasCommsHubEnabled = Businesses.find(function (Business) {
                    return BusinessId === Business.id && Business.services && Business.services.indexOf('ENTERPRISE_COMMUNICATION') > -1;
                });
                defer.resolve(!!isActiveEmployeeBusinessHasCommsHubEnabled);
            })
                .catch(function () {
                    defer.resolve(false);
                });

            return defer.promise;
        };

        self.isLPMEnabled = function () {
            return isServiceEnabled("POS");
        };

        self.isABSServiceEnabled = function () {
            return isServiceEnabled("ACTIVITY_BASED_SCHEDULING");
        };

        self.isScheduleBudgetingEnabled = function(brand){
            return false;
        };


        /**
         * Set the list of brands
         * @param brands
         */
        self.setBrands = function (brands) {
            _brands = brands;
        };


        self.resetBrands = function(){
            _brands = [];
        };


        self.prepareBrandWithNoAccessMap = function (brandId, brandsIds) {
            var defer = $q.defer();
            var unCachedBrands = [];

            brandsIds.forEach(function(id) {
                if (!self.getBrandById(id, true)) {
                    unCachedBrands.push(id);
                }
            });

            if (unCachedBrands.length) {
                var payload = {
                    brand_ids: unCachedBrands
                };
                GatewayTeamLiveAPI.getBrandsSettingsV3(brandId, payload)
                    .then(function (brandsSettings) {
                        brandsSettings.forEach(function(brand) {
                            brandWithNoAccessMap[brand.id] = brand;
                        });
                        defer.resolve();
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            else {
                defer.resolve();
            }
            return defer.promise;
        };

        self.checkIfBlendedRateEnabledOnCurrentWeek = function (brand) {
            const weekStartDay = Utils.getWeekStart(moment(), brand.startDayOfWeek || 'MON');
            for (const activeInterval of brand.blended_rate) {
                if (weekStartDay.isSameOrAfter(activeInterval.start_date) && (!activeInterval.end_date || weekStartDay.isSameOrBefore(activeInterval.end_date))) {
                    return true;
                }
            }
            return false;
        };

        self.getSwitchBrandStateDetails = function (toBrandId, toState, toParams) {
            var stateDetails = {};

            if ((parseInt(toBrandId) != parseInt(_activeBrand.id) || toParams.parentId)) {
                stateDetails['name'] = "teamlive_switch";
                stateDetails['params'] = {
                    fromId: toParams.parentId ? '' : _activeBrand.id,
                    fromState: $state.current.name,
                    fromParams: JSON.stringify($stateParams),
                    toId: toBrandId,
                    toState: toState,
                    toParams: JSON.stringify(toParams)
                };
            }
            else {
                stateDetails['name'] = toState;
                stateDetails['params'] = toParams;
            }

            return stateDetails;
        };

        self.getSwitchBrandURL = function (toBrandId, toState, toParams) {
            var stateDetails = self.getSwitchBrandStateDetails(toBrandId, toState, toParams);
            return $state.href(stateDetails['name'], stateDetails['params']);
        };
        var contextBrandId;
        /**
         * Get user barnds
         * @returns {*}
         */
        self.getBrands = function () {
            if (environmentsConfig.getEnv().host !== environmentsConfig.TEAM_SCHEDULE && contextBrandId !== hUser.getUserContext().brand_id) {
                self.resetBrands();
                contextBrandId = hUser.getUserContext().brand_id
            }

            if (_brands.length) {
                var defer = $q.defer();
                defer.resolve(_brands);
                return defer.promise;
            }

            // Send only one request in parallel, reuse same promise if already sent
            if (!getBrandsPromise) {
                getBrandsPromise = $q.defer();

                var method = '';
                if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                    method = TeamAPI.getEmployeeBrands();
                } else {
                    method = getEmployerBrandsList(contextBrandId);
                }
                method.then(function (res) {
                        _brands = res;
                        _activeBrand = {};

                        if (_brands.length != 0) {
                            getBrandsPromise.resolve(_brands);
                            getBrandsPromise = null;
                        } else {
                            getBrandsPromise.reject("No brands found for this user");
                            getBrandsPromise = null;
                        }

                    }, function (error) {
                        getBrandsPromise.reject(error);
                        getBrandsPromise = null;
                    });
            }

            return getBrandsPromise.promise;
        };

        var getEmployerBrandsList = function (contextBrandId) {
            var defer = $q.defer();

            userPermissions.getBrandPolicy(hUser.getEntryMode().brand_id).then(function (policyParser) {
                const hasAccessClosedLocationsPermission = policyParser.has(userPermissions.PERMISSIONS.ACCESS_CLOSED_LOCATIONS);
                userBrandsTreeService.getUserTLBrandsTree(hasAccessClosedLocationsPermission)
                    .then(function (brands) {
                        var parentBrand = brands.find(function (b) {
                            return b.id === contextBrandId;
                        });
                        var payload = {
                            brand_ids: parentBrand.brands.map(function (b) {
                                return b.id;
                            })
                        };
                        GatewayTeamLiveAPI.getBrandsSettingsV3(contextBrandId, payload)
                            .then(function (res) {
                                for (let brand of res) {
                                    let brandInParent = parentBrand.brands.find((b) => brand.id === b.id);
                                    brand.is_archived = brandInParent.is_archived;
                                }
                                defer.resolve(res);
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }).catch(function (err) {
                defer.reject(err);
            });

            return defer.promise;
        };

        var initActiveBrand = function () {
            if (!_brands || !_brands.length) {
                _activeBrand = {};
                return;
            }

            var isStateParamBrandFound = false;
            var brandFromState = $stateParams.brandId;

            if (angular.isArray(brandFromState)) {
                brandFromState = brandFromState[0];
            }

            if (brandFromState) {
                brandFromState = parseInt(brandFromState);
                var currentActiveId = _activeBrand && _activeBrand.id;
                isStateParamBrandFound = true;

                if (currentActiveId != brandFromState) {
                    for (var index in _brands) {
                        if (_brands[index].id == brandFromState) {
                            self.setActiveBrand(_brands[index]);
                            _activeBrand = _brands[index];
                            break;
                        }
                    }
                }
                $state.go('.', {brandId: "", gid: ""}, {reload: false, location: 'replace'});
            }

            if (!isStateParamBrandFound) {
                var teamScheduleEnv = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE;
                for (var index in _brands) {
                    var brand = _brands[index];
                    if (
                        (!teamScheduleEnv && brand.id === hUser.getActiveBrandIdWithAccess()) ||
                        (teamScheduleEnv && brand.is_default)
                    ) {
                        _activeBrand = brand;
                        break;
                    }
                }
            }

            if (!isStateParamBrandFound && !_activeBrand.hasOwnProperty('id')) {
                self.setActiveBrand(_brands[0], true);
                _activeBrand = _brands[0];
            }
        };

        var getBrandSources = function () {
            _activeBrand.sources = _activeBrand.sources || [];

            return _activeBrand.sources.sort(function (a, b) {

                if (a.code < b.code) {
                    return -1;
                }

                if (a.code > b.code) {
                    return 1;
                }

                return 0;
            });
        };

        /**
         * Gets the active brand
         * @returns {*|brand}
         */
        self.getActiveBrand = function () {
            var defer = $q.defer();
            const isTeamScheduleUser = EnvironmentsConfig.getEnv().host === EnvironmentsConfig.TEAM_SCHEDULE;

            if (
                !$stateParams.brandId &&
                _activeBrand.hasOwnProperty('id') &&
                (
                    isTeamScheduleUser ||
                    _activeBrand.id === hUser.getActiveBrandIdWithAccess()
                )
            ) {
                _activeBrand.sources = getBrandSources();
                defer.resolve(_activeBrand);
            } else {
                if (
                    _brands.length > 0 &&
                    (
                        isTeamScheduleUser ||
                        _brands.some((brand) => brand.id === hUser.getActiveBrandIdWithAccess())
                    )
                ) {
                    initActiveBrand();
                    _activeBrand.sources = getBrandSources();
                    defer.resolve(_activeBrand);
                } else {
                    self.getBrands()
                        .then(function (brands) {
                            _brands = brands;
                            initActiveBrand();
                            _activeBrand.sources = getBrandSources();
                            defer.resolve(_activeBrand);
                        }, function (error) {
                            _activeBrand = {};
                            defer.reject(error);
                        });
                }
            }

            return defer.promise;
        };

        self.getLocationsMappingUrl = function (brandId, param) {
            var defer = $q.defer();

            TeamAPI.getLocationsMappingUrl(brandId, param)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getCategoriesMappingUrl = function (brandId, param) {
            var defer = $q.defer();

            TeamAPI.getCategoriesMappingUrl(brandId, param)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getBusinessBrandById = function (businessId) {
            for (var i in userBusinesses) {
                if(userBusinesses[i].id === businessId) {
                    return userBusinesses[i];
                }
            }
            return null;
        };

        self.setActiveBusinessBrand = function (businessId) {
            if (userBusinesses.length) {
                _activeBusinessBrand = self.getBusinessBrandById(businessId);
            } else {
                self.getEmployeeBusinesses()
                    .then(function (businesses) {
                        for (var i in businesses) {
                            if (businesses[i].id === businessId) {
                                _activeBusinessBrand = businesses[i];
                            }
                        }
                    });
            }
        };

        self.getBrandsUnderBusiness = function (businessId) {
            var defer = $q.defer();
            if (businessBrandsMap[businessId]) {
                defer.resolve(businessBrandsMap[businessId]);
            }
            else {
                self.getBrands()
                    .then(function (brands) {
                        for (var j in brands) {
                            businessBrandsMap[brands[j].business_id] = businessBrandsMap[brands[j].business_id] || [];
                            businessBrandsMap[brands[j].business_id].push(brands[j]);
                        }
                        defer.resolve(businessBrandsMap[businessId]);
                    });
            }
            return defer.promise;

        };

        /**
         * Set active brand
         * @param brand
         */
        self.setActiveBrand = function (brand, dontNotify) {
            var defer = $q.defer();

            if (!brand || (brand.id == _activeBrand.id)) {
                defer.resolve(_activeBrand);
                return defer.promise;
            }

            if (!_activeBrand.hasOwnProperty('id') || (brand.id != _activeBrand.id)) {

                _activeBrand = self.getBrandById(brand.id);

                const promises = {};

                if (environmentsConfig.getEnv().host === environmentsConfig.TEAM_SCHEDULE) {
                    promises['brandDefault'] = TeamAPI.setDefaultBrand(brand.id);
                } else {
                    const context = hUser.getUserContext();
                    if (context.active_brand_id !== _activeBrand.id) {
                        hUser.setUserContext({
                            ...context,
                            active_brand_id: _activeBrand.id,
                            active_brand_type: _activeBrand.type
                        });
                    }
                }

                $q.all(promises).then(function (res) {
                    if (!dontNotify) {
                        emitter.trigger("brand-changed", angular.copy(_activeBrand), _activeBrand);
                    }
                    defer.resolve(_activeBrand);
                }, function (error) {
                    defer.reject(error);
                    console.error(error);
                });
            }

            return defer.promise;
        };

        self.getBrandById = function (brandId, checkBrandsWithNoAccess) {
            var noValidBrands = (!_brands || _brands.length === 0) && (!checkBrandsWithNoAccess || !brandWithNoAccessMap[brandId]);

            if (noValidBrands) {
                return undefined;
            }

            for (var index in _brands) {
                var brand = _brands[index];
                if (brand.id == brandId) {
                    return brand;
                }
            }

            if (checkBrandsWithNoAccess) {
                return brandWithNoAccessMap[brandId] || undefined;
            }

            return undefined;
        };


        self.normalizeBusinessDay = function (businessDay) {
            var dayOpenHour = businessDay ? businessDay.open_time * 1000 : 0; // From seconds to millis
            var dayCloseHour = businessDay ? businessDay.close_time * 1000 : 0; // From seconds to millis
            var closeTimeExtension = businessDay ? businessDay.close_time_extension * 1000 : 0;

            if (dayCloseHour <= dayOpenHour) {
                dayCloseHour += 24 * 60 * 60 * 1000; // One day shift
            }

            return {
                open_time: dayOpenHour,
                close_time: dayCloseHour,
                close_time_extension: closeTimeExtension,
                business_day: businessDay
            };
        };

        self.getBusinessDay = function (selectedDay, brandId, brandDetails) {
            var brand;
            if (brandDetails) {
                brand = brandDetails;
            } else {
                if (!brandId) {
                    brand = _activeBrand;
                } else {
                    brand = self.getBrandById(brandId);
                }
            }

            if (!brand) {
                return null;
            }

            var businessDays = brand.business_day;

            var selectedDayTime = selectedDay ? new Date(selectedDay).getTime() : new Date().getTime();
            var businessDay;
            for (var i in businessDays) {
                var businessDayTime = moment(businessDays[i].start_date, "YYYY-MM-DD").valueOf();
                if (selectedDayTime >= businessDayTime) {
                    businessDay = businessDays[i];
                    break;
                }
            }

            if (!businessDay) {
                businessDay = businessDays[businessDays.length - 1];
            }

            return self.normalizeBusinessDay(businessDay);
        };

        self.isUKBrand = function () {
            if (_activeBrand) {
                return _activeBrand.team_live_country_code === "UK";
            }
        };

        //Reload brand data on change
        self.reloadBrands = function () {
            contextBrandId = hUser.getUserContext().brand_id

            getEmployerBrandsList(contextBrandId)
                .then(function (brands) {
                    var activeBrandId = _activeBrand.id;

                    _brands = brands;
                    var brand = _.find(_brands, function (entry) {
                        return entry.id === activeBrandId;
                    });

                    emitter.trigger("brand-updated", angular.copy(_activeBrand), brand);
                    _activeBrand = brand;
                });
        };

        self.updateDayParts = function (dayParts) {
            var brandDayParts = angular.copy(_activeBrand.day_parts) || [];

            // update deleted brand day parts
            for (var i in brandDayParts) {
                if (!dayParts[brandDayParts[i].id]) {
                    brandDayParts[i].status = 'INACTIVE';
                }
            }

            // check if new/updated day parts
            for (var i in dayParts) {
                if (dayParts[i].tmp) {
                    continue;
                }
                var dayPart = {
                    id: dayParts[i].id,
                    status: 'ACTIVE',
                    name: dayParts[i].title,
                };

                if (dayParts[i].to) {
                    dayPart.end_time = dayParts[i].to.format("MMM DD, YYYY HH:mm");
                }
                if (dayParts[i].from) {
                    dayPart.start_time = dayParts[i].from.format("MMM DD, YYYY HH:mm");
                }

                let brandDayPartIndex = brandDayParts.findIndex(function (dp) {
                    return dp.id === dayPart.id;
                });

                if (brandDayPartIndex > -1) {
                    brandDayParts[brandDayPartIndex] = dayPart;
                }
                else {
                    brandDayParts.push(dayPart);
                }
            }
            _activeBrand.day_parts = brandDayParts;
        };

        self.getBrandPayTypePermissions = function (brand, viewPermission) {
            // If the brand has only 1 PAY_TYPE then we only check on 1 PERMISSION for that PAY_TYPE

            if (!brand.employee_payment_types || !brand.employee_payment_types.length) {
                console.warn("There are no brand payment types");
                return [];
            }

            var brandAppliedPermissions = [];

            for (var p = 0; p < brand.employee_payment_types.length; p++) {
                var brandPayType = brand.employee_payment_types[p];
                if (viewPermission) {
                    brandAppliedPermissions.push(userPermissions.PERMISSIONS['VIEW_' + brandPayType.type + '_EMPLOYEES_WAGES']);
                } else {
                    brandAppliedPermissions.push(userPermissions.PERMISSIONS['MANAGE_' + brandPayType.type + '_EMPLOYEES_WAGES']);
                }
            }

            return brandAppliedPermissions;
        };

        self.getEmployeeBusinesses = function () {
            var defer = $q.defer();
            if (userBusinesses && userBusinesses.length) {
                defer.resolve(angular.copy(userBusinesses));
            } else {
                TeamAPI.getEmployeeBusinesses().then(function (brands) {
                    userBusinesses = brands;
                    defer.resolve(angular.copy(brands))
                });
            }
            return defer.promise;
        };

        self.getEmployeeBusinessSettings = function (businessId) {
            var defer = $q.defer();
            if (employeeBusinessSettings[businessId]) {
                defer.resolve(angular.copy(employeeBusinessSettings[businessId]));
            } else {
                CoreReaderAPI.getEmployeeBusinessSettings(businessId)
                    .then(function (res) {
                        employeeBusinessSettings[businessId] = res;
                        defer.resolve(res);
                    }).catch(function (err) {
                    defer.reject(err);
                });
            }
            return defer.promise;
        }

        function getFormattedPayType(payTypeItem, hourlyCount) {

            var payType = {
                "type": payTypeItem.type,
                "cross_location_edit_mode": payTypeItem.cross_location_edit_mode,
                "track_mode": payTypeItem.track_mode,
            };

            if (payTypeItem.type === 'HOURLY') {
                if (hourlyCount && hourlyCount > 1) {
                    if (payTypeItem.cross_location_edit_mode === 'FIXED') {
                        payType.name = $filter("translate")("Hourly Fixed");
                    }
                    if (payTypeItem.cross_location_edit_mode === 'FLEXIBLE') {
                        payType.name = $filter("translate")("Hourly Flexible");
                    }

                    payType.mode = payTypeItem.type + '_' + payTypeItem.cross_location_edit_mode;
                } else {
                    payType.name = $filter("translate")("Hourly");
                    payType.mode = payTypeItem.type;
                }
            } else {
                if (payTypeItem.type === 'WEIGHTED_SHIFT') {
                    payType.name = $filter("translate")("Shift Based");
                }
                if (payTypeItem.type === 'SALARIED') {
                    payType.name = $filter("translate")("Salaried");
                }

                payType.mode = payTypeItem.type;
            }

            return payType;
        }

        self.getBrandPayTypesPerUserPermissions = function (brand, allCategories, allPayTypes, viewOrManagePermission) {

            var deferred = $q.defer();

            userPermissions
                .getBrandPolicy(brand.id)
                .then(function (policyParser) {

                    if (!brand.employee_payment_types || !brand.employee_payment_types.length) {
                        deferred.reject({ error: "There are no brand payment types" });
                    }

                    var payTypes = [];

                    if (!allPayTypes) {
                        var appliedPermissionsForPayTypes = self.getBrandPayTypePermissions(brand);

                        if (allCategories) {
                            policyParser = policyParser.categories(policyParser.ALL);
                        }

                        var WAGE_ACCESS = {};
                        WAGE_ACCESS.ALL = policyParser.hasAll(appliedPermissionsForPayTypes);
                        WAGE_ACCESS.ANY = policyParser.hasAny(appliedPermissionsForPayTypes);

                        if (!WAGE_ACCESS.ALL) {
                            if (viewOrManagePermission) {
                                WAGE_ACCESS.HOURLY = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES, userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES]);
                                WAGE_ACCESS.SALARIED = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_WAGES, userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES]);
                                WAGE_ACCESS.WEIGHTED_SHIFT = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES, userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES]);
                            } else {
                                WAGE_ACCESS.HOURLY = policyParser.has(userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES);
                                WAGE_ACCESS.SALARIED = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_WAGES);
                                WAGE_ACCESS.WEIGHTED_SHIFT = policyParser.has(userPermissions.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES);
                            }
                        }
                    }

                    var hourlyCount = _.countBy(brand.employee_payment_types, function (payType) { return payType.type })['HOURLY'];

                    for (var i = 0; i < brand.employee_payment_types.length; i++) {

                        var payTypeItem = brand.employee_payment_types[i];

                        if (!allPayTypes) {
                            if (!WAGE_ACCESS.ALL) {
                                if (!WAGE_ACCESS[payTypeItem.type]) {
                                    continue;
                                }
                            }
                        }

                        payTypes.push(getFormattedPayType(payTypeItem, hourlyCount));
                    }

                    deferred.resolve(payTypes);
                });

            return deferred.promise;
        };

        self.isLoaEnabled = function(brand) {
            var loaSetting = brand['brand_absences'] && brand['brand_absences'].find(function (absence) {
                return absence.type == 'LOA';
            });
            return !!loaSetting;
        }

        return self;
    }


    angular
        .module('harriApp')
        .service('TeamScheduleService', ["hUser", "userPermissions", "$stateParams", "$state", "userBrandsTreeService", "$q",
            function (hUser, userPermissions, $stateParams, $state, userBrandsTreeService, $q) {
                return new TeamScheduleService(hUser, userPermissions, $stateParams, $state, userBrandsTreeService, $q);
            }]);

})(angular, TeamAPI, TSUtils);
